module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project get-clean"
  }, [_c('project-header', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "project-gallery row"
  }, [_c('div', {
    staticClass: "col-12 get-clean__dirty-truth"
  }, [_c('video', {
    staticClass: "no-scrollplay",
    attrs: {
      "poster": "/static/images/get-clean/poster.jpg",
      "playsinline": "",
      "controls": ""
    },
    on: {
      "click": function($event) {
        $event.target.paused ? $event.target.play() : $event.target.pause()
      }
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/get-clean/dirty_truth_video.mp4"
    }
  })])]), _vm._v(" "), _vm._l((_vm.identity), function(image) {
    return _c('div', {
      key: image,
      staticClass: "col-12 project-gallery__img"
    }, [_c('img', {
      staticClass: "project-gallery__image",
      attrs: {
        "src": ("/static/images/get-clean/" + image)
      }
    })])
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "col-10 col-6-md col-5-lg project-gallery__icons",
    attrs: {
      "src": "/static/images/get-clean/get-clean-icons-left.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-10 col-6-md col-5-lg project-gallery__icons project-gallery__icons--last",
    attrs: {
      "src": "/static/images/get-clean/get-clean-icons-right.svg"
    }
  }), _vm._v(" "), _vm._l((_vm.process), function(image) {
    return _c('div', {
      key: image,
      staticClass: "col-12 project-gallery__img"
    }, [_c('img', {
      staticClass: "project-gallery__image",
      attrs: {
        "src": ("/static/images/get-clean/" + image)
      }
    })])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.packaging), function(image) {
    return _c('div', {
      key: image,
      staticClass: "col-12 project-gallery__img"
    }, [_c('img', {
      staticClass: "project-gallery__image",
      attrs: {
        "src": ("/static/images/get-clean/" + image)
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.products), function(image) {
    return _c('div', {
      key: image,
      staticClass: "col-12 project-gallery__img"
    }, [_c('img', {
      staticClass: "project-gallery__image",
      attrs: {
        "src": ("/static/images/get-clean/" + image)
      }
    })])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.promo), function(image) {
    return _c('div', {
      key: image,
      staticClass: "col-12 project-gallery__img"
    }, [_c('img', {
      staticClass: "project-gallery__image",
      attrs: {
        "src": ("/static/images/get-clean/" + image)
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 project-gallery__video-container"
  }, [_c('website-video', {
    attrs: {
      "sources": ['/static/videos/get-clean/getclean-web-index-scroll-desktop.mp4']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 project-gallery__video-container"
  }, [_c('website-video', {
    attrs: {
      "sources": ['/static/videos/get-clean/get-clean-scroll-mobile.mp4'],
      "portrait": true
    }
  })], 1)], 2), _vm._v(" "), _c('project-footer', {
    attrs: {
      "prev": "/work/clean-sound",
      "next": "/work/incbues"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 project-gallery__fullsize-video project-gallery__double-video"
  }, [_c('div', {
    staticClass: "video-fix"
  }, [_c('video', {
    staticClass: "project-gallery__video col-12",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/get-clean/get-clean-logo-gif.mp4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-fix"
  }, [_c('video', {
    staticClass: "project-gallery__video col-12",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/get-clean/get-clean-splash-gif.mp4"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 ta-center video-fix get-clean__products"
  }, [_c('div', [_c('video', {
    staticClass: "project-gallery__fullsize-video",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/get-clean/products-gif.mp4"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 get-clean__robobs"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/get-clean/dance.mp4"
    }
  })]), _vm._v(" "), _c('video', {
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/get-clean/snow-angel.mp4"
    }
  })]), _vm._v(" "), _c('video', {
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/get-clean/r2d2.mp4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fc3fc5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/GetClean.vue
// module id = 384
// module chunks = 2